import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "c-modal-message-card" }
const _hoisted_2 = { class: "c-modal-message-card__content" }
const _hoisted_3 = {
  key: 0,
  class: "c-modal-message-card__header"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "c-modal-message-buttons" }

import { PropType, computed } from 'vue';
import { modalController } from '@ionic/vue';
import { ModalMessageButtonItem } from '@/composables/messages';
import { textLinkToHtmlLink, nl2br } from '@/utils/string';


export default /*#__PURE__*/_defineComponent({
  props: {
  header: {
    type: String,
    required: false,
  },
  message: {
    type: String,
    required: false,
  },
  closeButton: {
    type: Boolean,
    default: true,
  },
  buttons: {
    type: Array as PropType<ModalMessageButtonItem[]>,
    default: () => [],
  }
},
  setup(__props) {

const props = __props



function close() {
  modalController.dismiss();
}

const preparedMessage = computed(() => textLinkToHtmlLink(nl2br(props.message || '')));


return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_button, {
      fill: "default",
      class: "c-modal-message-card__close-button",
      onClick: close
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_icon, { name: "core-close" })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      (props.header)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.header), 1))
        : _createCommentVNode("", true),
      (props.message)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "c-modal-message-card__message",
            innerHTML: _unref(preparedMessage)
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.buttons, (button, index) => {
        return (_openBlock(), _createBlock(_component_ion_item, {
          key: index,
          button: "",
          detail: false,
          onClick: button.handler,
          class: _normalizeClass(["c-modal-message-buttons__button item-link-button ion-text-center item-no-detail-icon", button.cssClass])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_label, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(button.text), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["onClick", "class"]))
      }), 128))
    ])
  ]))
}
}

})